// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_baths(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DevelopmentProjectUnitBathsRange",
    "DevelopmentProjectUnitExactBaths"
  ]);
}

function unwrap_fragment_beds(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DevelopmentProjectUnitBedsRange",
    "DevelopmentProjectUnitExactBeds"
  ]);
}

function unwrap_fragment_squareFeet(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DevelopmentProjectUnitExactSquareFeet",
    "DevelopmentProjectUnitSquareFeetRange"
  ]);
}

let fragmentConverter = {"__root":{"squareFeet":{"u":"fragment_squareFeet"},"beds":{"u":"fragment_beds"},"baths":{"u":"fragment_baths"}}};

let fragmentConverterMap = {
  fragment_baths: unwrap_fragment_baths,
  fragment_beds: unwrap_fragment_beds,
  fragment_squareFeet: unwrap_fragment_squareFeet
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "beds",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "beds",
              "storageKey": null
            }
          ],
          "type": "DevelopmentProjectUnitExactBeds",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minBeds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxBeds",
              "storageKey": null
            }
          ],
          "type": "DevelopmentProjectUnitBedsRange",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "baths",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baths",
              "storageKey": null
            }
          ],
          "type": "DevelopmentProjectUnitExactBaths",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minBaths",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxBaths",
              "storageKey": null
            }
          ],
          "type": "DevelopmentProjectUnitBathsRange",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "squareFeet",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "squareFeet",
              "storageKey": null
            }
          ],
          "type": "DevelopmentProjectUnitExactSquareFeet",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minSquareFeet",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxSquareFeet",
              "storageKey": null
            }
          ],
          "type": "DevelopmentProjectUnitSquareFeetRange",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentProjectSampleUnit",
  "abstractKey": null
};
})());

let wrap_fragment_baths = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_beds = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_squareFeet = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_baths = unwrap_fragment_baths;
exports.wrap_fragment_baths = wrap_fragment_baths;
exports.unwrap_fragment_beds = unwrap_fragment_beds;
exports.wrap_fragment_beds = wrap_fragment_beds;
exports.unwrap_fragment_squareFeet = unwrap_fragment_squareFeet;
exports.wrap_fragment_squareFeet = wrap_fragment_squareFeet;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
